var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100"},[_c('main',{staticClass:"h-100",attrs:{"role":"main"}},[_c('common-master-table',{ref:"commonMasterTable",attrs:{"primary-key":"rcsSerialId","table-no":"mstRcs","table-api":"master/rcs","editable":_vm.editableMixin.rcs,"addable":_vm.editableMixin.rcs,"mapping-no":"ie-rcs","socket-entity":"RCS_SOCKET"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17de0895","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mst-tables/RcsMaster.vue
// module id = null
// module chunks = 